import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import FormActions from 'views/Components/FormActions';
import FormStatusSwitch from 'views/Components/FormStatusSwitch';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class OpcionalVeiculoForm extends Component {
    state = {
        isNewRecord: false,
        isView: false,
        opcionalveiculo: {
            codopcionalveiculo: '',
            descopcionalveiculo: '',
            inativoopc: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descopcionalveiculo: {
                presence: { allowEmpty: false, message: 'Descrição do opcional obrigatória' },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    opcionalveiculo: this.getOpcionalVeiculoDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadOpcionalVeiculo(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar opcional de veículo:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar opcional de veículo!'
                )
            );
        }
    };

    /* Retorna o opcional de veículo padrão */
    getOpcionalVeiculoDefault = () => ({
        codopcionalveiculo: '',
        descopcionalveiculo: '',
        inativoopc: ANAO
    });

    /* Carrega o opcional de veículo */
    loadOpcionalVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/opcionalveiculo/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Opcional de veículo não encontrado!');

            history.push('/frotas/opcionalveiculo');

            return;
        }

        this.setState({
            opcionalveiculo: {
                codopcionalveiculo: registro.codopcionalveiculo || '',
                descopcionalveiculo: registro.descopcionalveiculo || '',
                inativoopc: registro.inativoopc || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            opcionalveiculo: {
                ...prevState.opcionalveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de opcional de veículo */
    getPayloadOpcionalVeiculo = () => {
        const { opcionalveiculo } = this.state;

        return {
            descopcionalveiculo: opcionalveiculo.descopcionalveiculo || '',
            inativoopc: opcionalveiculo.inativoopc || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { opcionalveiculo, isNewRecord } = this.state;
        const { history, loadOpcionalVeiculo } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadOpcionalVeiculo();

            if (isNewRecord) {
                await api.post('/opcionalveiculo', payload);
            } else {
                await api.put(`/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}`, payload);
            }

            if (loadOpcionalVeiculo) loadOpcionalVeiculo();

            history.push('/frotas/opcionalveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/opcionalveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { opcionalveiculo, schema } = this.state;

        return validateSchemaFields(
            opcionalveiculo,
            schema,
            ['descopcionalveiculo']
        );
    };

    render() {
        const {
            errors,
            isView,
            messageAlert,
            opcionalveiculo,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Opcional de veículos {opcionalveiculo.codopcionalveiculo}
                        </Typography>

                        <FormStatusSwitch
                            checked={opcionalveiculo.inativoopc !== ASIM}
                            name="inativoopc"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descopcionalveiculo"
                            value={opcionalveiculo.descopcionalveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descopcionalveiculo || ''}
                            error={!!errors.descopcionalveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default OpcionalVeiculoForm;